// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
  }
  
   
  .hero-hero-section {
    padding-top: 30px;
    padding: 0 20px;
    position: relative;
    height: 85vh;
    transition: all 0.5s ease-in-out; /* Smooth transition */
  }
  
  .hero-hero-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
    min-height: 1183px;
   
    inset: -130px 0 auto;
  }
  
  .hero-hero-bg img {

    width: 65%;
    height: 65%;
    transition: transform 0.5s ease-in-out; /* Add smooth scaling */
  }
  .hero-hero-section:hover .hero-hero-bg img {
    transform: scale(1.1); /* Slight zoom effect */
  }
  
  .hero-hero-container {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    gap: 30px;
  }
  
  .hero-hero-left-container {
    flex: 1 1 100%;
    display: flex;
    margin-bottom: 3rem;
    flex-direction: column;
    justify-content: center;
  }
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .hero-hero-left-container h1 {
    font-size: 70px;
    color: var(--primary-black2);
    animation: slideIn 1s ease-in-out;
  }
  
  .hero-hero-left-container h2 {
    font-size: 70px;
    color: var(--primary-black2);
    animation: slideIn 1.2s ease-in-out;
  }
  
  .hero-hero-left-container p {
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 3rem;
    color: var(--primary-grey);
  }
  
  .hero-hero-btn-box {
    display: flex;
    gap: 20px;
  }
  
  .hero-hero-btn-box button {
    width: 200px;
    overflow: none;
    font-size: 20px;
    cursor: pointer;
    font-weight: 400;
    padding: 24px 10px;
    border-radius: 12px;
    transition: 0.3s linear;
  }
  
  .hero-hero-btn-box button:first-child {
    border: none;
    color: var(--primary-white);
    background-color: var(--primary-blue);
  }
  
  .hero-hero-btn-box button:last-child {
    color: var(--primary-blue);
    border: 1px solid #ececf6;
    box-shadow: 0 3px 18px 0 #4a3aff1c;
    background-color: var(--primary-white);
  }
  
  .hero-hero-btn-box button:hover {
    transform: translateY(-5px);
  }
  
  .hero-hero-btn-box button:hover:first-child {
    background-color: #555ae6;
    box-shadow: 1px 1px 10px #6d72f6;
  }
  
  .hero-hero-btn-box button:hover:last-child {
    color: var(--primary-green);
    box-shadow: 0 3px 18px 0 #4a3aff3b;
  }
  
  .hero-hero-right-container {
    flex: 1 1 100%;
    position: relative;
    display: flex;
    overflow: visible; /* Allow the image to extend beyond the container */
    align-items: center;
    justify-content: flex-end; /* Keep alignment for other potential elements */

  }
  
  .hero-hero-right-container img {
    position: absolute; /* Use absolute positioning for precise control */
    right: -80px; /* Move the image further to the right */
    top: 50%; /* Center the image vertically */
    transform: translateY(-50%); /* Adjust for vertical centering */
    width: 135%; /* Increase the image size */
    max-width: none; /* Remove max-width restriction */
    pointer-events: none;
   
  }
  
  
  @media (max-width: 1300px){
    .hero-hero-right-container img {
      width: 100%; 
      right: 0px;
    }
  }
  @media (max-width: 1024px) {
    .hero-hero-section{
      height: auto;
    }
    .hero-hero-container {
      flex-direction: column;
      text-align: center;
      gap: 20px;
    }
  
    .hero-hero-left-container h1,
    .hero-hero-left-container h2 {
      font-size: 50px;
    }
  
    .hero-hero-left-container p {
      font-size: 18px;
      width: 100%;
      max-width: 650px;
      margin: 24px auto;
    }

    .hero-hero-btn-box{
      justify-content: center;
    }

    .hero-hero-btn-box button{
      width: 180px;
      font-size: 18px;
      padding: 20px 10px;
    }
  
    .hero-hero-right-container{
      justify-content: center;
    }

    .hero-hero-right-container img {
      width: 100%; 
      max-width: 550px;
      position: relative;
      transform: translateX(0); 
    }

    .hero-hero-bg {
      inset: 130px 0 auto;
    }
  }
  
  @media (max-width: 768px) {
    .hero-hero-left-container h1,
    .hero-hero-left-container h2 {
      font-size: 40px;
    }
  
    .hero-hero-left-container p {
      font-size: 16px;
    }
  
    .hero-hero-btn-box button {
      width: 140px;
      font-size: 16px;
    }
  }
  
  @media (max-width: 480px) {
    .hero-hero-section {
      padding: 10px;
    }
  
    .hero-hero-left-container h1,
    .hero-hero-left-container h2 {
      font-size: 30px;
    }
  
    .hero-hero-left-container p {
      font-size: 14px;
    }
  
    .hero-hero-btn-box button {
      font-size: 14px;
    }
  
    .hero-hero-right-container img {
      width: 90%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Hero/Hero.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;EAC3B;;;EAGA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gCAAgC,EAAE,sBAAsB;EAC1D;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,kBAAkB;;IAElB,oBAAoB;EACtB;;EAEA;;IAEE,UAAU;IACV,WAAW;IACX,sCAAsC,EAAE,uBAAuB;EACjE;EACA;IACE,qBAAqB,EAAE,uBAAuB;EAChD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,kCAAkC;IAClC,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,iBAAiB,EAAE,mDAAmD;IACtE,mBAAmB;IACnB,yBAAyB,EAAE,gDAAgD;;EAE7E;;EAEA;IACE,kBAAkB,EAAE,iDAAiD;IACrE,YAAY,EAAE,wCAAwC;IACtD,QAAQ,EAAE,gCAAgC;IAC1C,2BAA2B,EAAE,kCAAkC;IAC/D,WAAW,EAAE,4BAA4B;IACzC,eAAe,EAAE,iCAAiC;IAClD,oBAAoB;;EAEtB;;;EAGA;IACE;MACE,WAAW;MACX,UAAU;IACZ;EACF;EACA;IACE;MACE,YAAY;IACd;IACA;MACE,sBAAsB;MACtB,kBAAkB;MAClB,SAAS;IACX;;IAEA;;MAEE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,WAAW;MACX,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,YAAY;MACZ,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,kBAAkB;MAClB,wBAAwB;IAC1B;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;;MAEE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;;MAEE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,UAAU;IACZ;EACF","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n  }\n  \n   \n  .hero-hero-section {\n    padding-top: 30px;\n    padding: 0 20px;\n    position: relative;\n    height: 85vh;\n    transition: all 0.5s ease-in-out; /* Smooth transition */\n  }\n  \n  .hero-hero-bg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    overflow: hidden;\n    min-height: 1183px;\n   \n    inset: -130px 0 auto;\n  }\n  \n  .hero-hero-bg img {\n\n    width: 65%;\n    height: 65%;\n    transition: transform 0.5s ease-in-out; /* Add smooth scaling */\n  }\n  .hero-hero-section:hover .hero-hero-bg img {\n    transform: scale(1.1); /* Slight zoom effect */\n  }\n  \n  .hero-hero-container {\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n    max-width: 1200px;\n    display: flex;\n    gap: 30px;\n  }\n  \n  .hero-hero-left-container {\n    flex: 1 1 100%;\n    display: flex;\n    margin-bottom: 3rem;\n    flex-direction: column;\n    justify-content: center;\n  }\n  \n  @keyframes slideIn {\n    from {\n      opacity: 0;\n      transform: translateY(50px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .hero-hero-left-container h1 {\n    font-size: 70px;\n    color: var(--primary-black2);\n    animation: slideIn 1s ease-in-out;\n  }\n  \n  .hero-hero-left-container h2 {\n    font-size: 70px;\n    color: var(--primary-black2);\n    animation: slideIn 1.2s ease-in-out;\n  }\n  \n  .hero-hero-left-container p {\n    font-size: 20px;\n    margin-top: 20px;\n    margin-bottom: 3rem;\n    color: var(--primary-grey);\n  }\n  \n  .hero-hero-btn-box {\n    display: flex;\n    gap: 20px;\n  }\n  \n  .hero-hero-btn-box button {\n    width: 200px;\n    overflow: none;\n    font-size: 20px;\n    cursor: pointer;\n    font-weight: 400;\n    padding: 24px 10px;\n    border-radius: 12px;\n    transition: 0.3s linear;\n  }\n  \n  .hero-hero-btn-box button:first-child {\n    border: none;\n    color: var(--primary-white);\n    background-color: var(--primary-blue);\n  }\n  \n  .hero-hero-btn-box button:last-child {\n    color: var(--primary-blue);\n    border: 1px solid #ececf6;\n    box-shadow: 0 3px 18px 0 #4a3aff1c;\n    background-color: var(--primary-white);\n  }\n  \n  .hero-hero-btn-box button:hover {\n    transform: translateY(-5px);\n  }\n  \n  .hero-hero-btn-box button:hover:first-child {\n    background-color: #555ae6;\n    box-shadow: 1px 1px 10px #6d72f6;\n  }\n  \n  .hero-hero-btn-box button:hover:last-child {\n    color: var(--primary-green);\n    box-shadow: 0 3px 18px 0 #4a3aff3b;\n  }\n  \n  .hero-hero-right-container {\n    flex: 1 1 100%;\n    position: relative;\n    display: flex;\n    overflow: visible; /* Allow the image to extend beyond the container */\n    align-items: center;\n    justify-content: flex-end; /* Keep alignment for other potential elements */\n\n  }\n  \n  .hero-hero-right-container img {\n    position: absolute; /* Use absolute positioning for precise control */\n    right: -80px; /* Move the image further to the right */\n    top: 50%; /* Center the image vertically */\n    transform: translateY(-50%); /* Adjust for vertical centering */\n    width: 135%; /* Increase the image size */\n    max-width: none; /* Remove max-width restriction */\n    pointer-events: none;\n   \n  }\n  \n  \n  @media (max-width: 1300px){\n    .hero-hero-right-container img {\n      width: 100%; \n      right: 0px;\n    }\n  }\n  @media (max-width: 1024px) {\n    .hero-hero-section{\n      height: auto;\n    }\n    .hero-hero-container {\n      flex-direction: column;\n      text-align: center;\n      gap: 20px;\n    }\n  \n    .hero-hero-left-container h1,\n    .hero-hero-left-container h2 {\n      font-size: 50px;\n    }\n  \n    .hero-hero-left-container p {\n      font-size: 18px;\n      width: 100%;\n      max-width: 650px;\n      margin: 24px auto;\n    }\n\n    .hero-hero-btn-box{\n      justify-content: center;\n    }\n\n    .hero-hero-btn-box button{\n      width: 180px;\n      font-size: 18px;\n      padding: 20px 10px;\n    }\n  \n    .hero-hero-right-container{\n      justify-content: center;\n    }\n\n    .hero-hero-right-container img {\n      width: 100%; \n      max-width: 550px;\n      position: relative;\n      transform: translateX(0); \n    }\n\n    .hero-hero-bg {\n      inset: 130px 0 auto;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .hero-hero-left-container h1,\n    .hero-hero-left-container h2 {\n      font-size: 40px;\n    }\n  \n    .hero-hero-left-container p {\n      font-size: 16px;\n    }\n  \n    .hero-hero-btn-box button {\n      width: 140px;\n      font-size: 16px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .hero-hero-section {\n      padding: 10px;\n    }\n  \n    .hero-hero-left-container h1,\n    .hero-hero-left-container h2 {\n      font-size: 30px;\n    }\n  \n    .hero-hero-left-container p {\n      font-size: 14px;\n    }\n  \n    .hero-hero-btn-box button {\n      font-size: 14px;\n    }\n  \n    .hero-hero-right-container img {\n      width: 90%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
